import { apiGet, planningPath } from './PlanningApiClient';

// The other half of a record's timeline, and the exact counterpart of
// CommentsService: one backend table keyed by (entity_type, entity_id), so
// giving a record its own audit trail is UI wiring rather than a new
// schema/repo/route each time. See ans-backend's db/schema/planning.ts
// `entity_status_history` for why this replaced per-entity history tables.
//
// Read-only on purpose — history is written server-side as a side effect of
// the edit that caused it, never posted by a client.
export type StatusHistoryEntityType =
  | 'asoebi_order'
  | 'asoebi_assignment'
  | 'asoebi_delivery'
  | 'vendor_booking'
  | 'task';

export interface EntityStatusChange {
  id: string;
  fromStatus: string | null;
  toStatus: string;
  changedAtISO: string;
  source: string | null;
  /** Email of whoever caused the change; null for an automated transition. */
  actor: string | null;
  notes: string | null;
}

interface ApiStatusChange {
  id: number | string;
  from_status: string | null;
  to_status: string;
  changed_at: string;
  source: string | null;
  actor: string | null;
  notes: string | null;
}

function mapApiEntry(row: ApiStatusChange): EntityStatusChange {
  return {
    id: String(row.id),
    fromStatus: row.from_status,
    toStatus: row.to_status,
    changedAtISO: row.changed_at,
    source: row.source,
    actor: row.actor,
    notes: row.notes,
  };
}

export async function loadStatusHistory(
  entityType: StatusHistoryEntityType,
  entityId: string
): Promise<EntityStatusChange[]> {
  const res = await apiGet<{ entries: ApiStatusChange[] }>(
    planningPath(`/status-history?entity_type=${entityType}&entity_id=${entityId}`)
  );
  return (res?.entries ?? []).map(mapApiEntry);
}
